import * as React from 'react'
import { useMemo } from 'react'
import BaseTimeSuggestionOverview, { BaseTimeSuggestionOverviewProps, TimeSuggestionFilterType } from './BaseTimeSuggestionOverview'

export default function TimeSuggestionOverview(props?: BaseTimeSuggestionOverviewProps) {
    const fixedFilterValues = useMemo<Partial<TimeSuggestionFilterType>>(
        () => ({
            files: props.fileId ? [props.fileId] : undefined,
        }),
        [],
    )

    return <BaseTimeSuggestionOverview {...props} fixedFilterValues={fixedFilterValues} hideFileField={!!props.fileId} />
}
